import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import {
  addDoc,
  collection,
  doc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import ErrorMessages from "helper/errorMessages";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function AddBatches() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [batchesHeading, setBatchesHeading] = useState(
    CommonHeadings.batchAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [batchesID, setBatchesID] = useState();
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [batches, setBatches] = useState({
    batch_name: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    batch_name: "",
    description: "",
  });

  // MARK: use effect 
  useEffect(() => {
    if (location.state) {
      setEditBatchesUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // use layout method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.batchEditHeading
      : CommonHeadings.batchAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const validateForm = (data) => {
    const errors = {};

    if (!data.batch_name) {
      errors.batch_name = ErrorMessages.batchName;
    }
    if (!data.description) {
      errors.description = ErrorMessages.description;
    }

    return errors;
  };

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    setBatches({
      ...batches,
      [name]: value,
    });
  };

  // MARK: edit data function
  function setEditBatchesUI() {
    setBatches((prevState) => ({
      ...prevState,
      batch_name: location.state.batch_name,
      description: location.state.description,
    }));
    setBatchesHeading(CommonHeadings.batchEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setBatchesID(location.state.firebase_id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...batches,
      created_at: createdAt,
      updated_at: null,
    };
    object.batch_name = batches.batch_name.toLowerCase();
    object.description = batches.description.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setBatches({
      batch_name: "",
      description: "",
    });
  }

  // MARK:API
  async function writeBatchesApi(edit) {
    try {
      await addDoc(collection(dbFirestore, TableName.batches), {
        ...payload(),
      });

      if (edit) {
        toast.success(ToastMessages.batchAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addBatches);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.batchAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.batchesList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update API
  async function updateBatchesApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();

    try {
      await updateDoc(doc(dbFirestore, TableName.batches, batchesID), {
        ...updatedPayload,
      });
      toast.success(ToastMessages.batchUpdated);

      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.batchesList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: button function
  const tapOnSave = () => {
    const newErrors = validateForm(batches);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateBatchesApi();
      } else {
        writeBatchesApi();
      }
    }
  };

  const tapOnSaveNext = () => {
    const newErrors = validateForm(batches);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeBatchesApi(true);
    }
  };

  // MARK: data pass dynamically in row and columns
  const rowBatcheData = [
    {
      name: "batch_name",
      value: batches.batch_name,
      change: inputChange,
      type: "text",
      placeholder: "Enter batch name",
      label: "Batch Name",
      className: "p-error",
      error: errors.batch_name,
    },
    {
      name: "description",
      value: batches.description,
      change: inputChange,
      placeholder: "Enter description",
      label: "Description",
      type: "text",
      className: "p-error",
      error: errors.description,
    },
  ];


  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName={batchesHeading} />
          <div className="p-fluid">
          <div className="row modules__row">
            {rowBatcheData.map((col) => (
              <div className="col-12 col-md-6">
                <label htmlFor={col.name} className="input__valid">{col.label}</label>
                <InputText
                  name={col.name}
                  value={col.value}
                  onChange={col.change}
                  id={col.name}
                  type={col.type}
                  placeholder={col.placeholder}
                />
                {isSubmitted && (
                  <small id={col.name} className={col.className}>
                    {col.error}{" "}
                  </small>
                )}
              </div>
            ))}
          </div>
          </div>

          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>

    
      </div>
    </div>
  );
}
export default AddBatches;
